var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{style:({
      'background-color': _vm.color,
      color: 'white',
    })},[_c('h5',{style:({
        color: _vm.getSecondaryColor,
        textAlign: 'center',
      })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }